import api from './api'

const basePath =  '/api/v1/products'

const createDataError = (err, message) => ({error:{user:message, tech: err}})


export const getProduct = async id => {
    const userMessage = `Falha ao consultar o produto ID ${id} Tente Novamente!`
    let data = {}

    try {
        const response = await api.get(`${basePath}/${id}/`)
        if (response.status === 200){
            data = response.data
        } else {
            throw new Error(`Resposta do servidor ${response.status}`)
        }
    } catch (error) {
        data = createDataError(error, userMessage)
    } finally {
        return data
    }
}

export const getProducts =  async (params={}, page=1, limit=10) => {
    const userMessage = `Não foi possivel encontrar o produto`
    let data = []
    let response = null
    try {
        if (params.name){
            response = await api.get(`${basePath}/?name=${params.name}`)
        } else {
            response = await api.get(basePath)
        }
        if (response.status === 200){
            data = response.data
        } else {
            throw new Error(`Resposta do servidor ${response.status}`)
        }
    } catch (error) {
        data = createDataError(error, userMessage)
    } finally {
        return data
    }
}